export default (state) => state.category.error;
